"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginJourneyRenderingPage = void 0;
var core_1 = require("@athena-portal/core");
var Types_1 = require("./Types");
var PluginJourneyRenderingPage_1 = require("./pages/PluginJourneyRenderingPage");
var SessionErrorPage_1 = require("./pages/SessionErrorPage");
var messages_1 = require("./messages");
var journeyServices = require("@athena-portal/journey-services");
var services = require("./services");
var widgets = require("./widgets");
var navigators = require("./navigator");
var commands = require("./commands");
var journey_model_1 = require("@athena-portal/journey-model");
var plugin = {
    getName: function () {
        return "plugin-journey";
    },
    register: function (extensions, configuration) {
        // Routes
        extensions.routes.add({
            path: "/journey/:action/product/:product/process/:process/:pageId?/:interactionId?",
            component: PluginJourneyRenderingPage_1.LocalizablePluginJourneyRenderingPage,
            exact: true,
        });
        // Widgets
        extensions.journeyComponents.addQuestionComponent({
            id: "textBox",
            component: widgets.TextBoxQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "textArea",
            component: widgets.TextAreaQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "dropDownBox",
            component: widgets.DropDownBoxQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "autoCompleteBox",
            component: widgets.AutoCompleteQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "checkBox",
            component: widgets.CheckBoxQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "multiCheckbox",
            component: widgets.MultiCheckboxQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "switch",
            component: widgets.SwitchQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "radio",
            component: widgets.RadioQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "group",
            component: widgets.GroupQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "panel",
            component: widgets.PanelQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "rangeSlider",
            component: widgets.RangeSliderQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "datePicker",
            component: widgets.DatePickerQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "button",
            component: widgets.ButtonWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "card",
            component: widgets.CardLayoutWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "text",
            component: widgets.TextWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "htmlOutput",
            component: widgets.HTMLOutputWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "lookupValue",
            component: widgets.LookupValueWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "link",
            component: widgets.LinkWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "buttonGroup",
            component: widgets.ButtonGroupQuestionWidget,
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "validationSummary",
            component: widgets.ValidationSummaryWidget
        });
        extensions.journeyComponents.addQuestionComponent({
            id: "modal",
            component: widgets.ModalLayoutWidget,
        });
        // Navigators
        extensions.journeyComponents.addNavigatorComponent({
            id: "default",
            component: navigators.DefaultNavigator
        });
        extensions.journeyComponents.addNavigatorComponent({
            id: "breadcrumbs",
            component: navigators.BreadcrumbsNavigator
        });
        extensions.journeyComponents.addNavigatorComponent({
            id: "accordion",
            component: navigators.AccordionNavigator
        });
        // Commands
        extensions.journeyComponents.addCommand({
            id: "calculate",
            component: commands.CalculateCommand
        });
        extensions.journeyComponents.addCommand({
            id: "validate",
            component: commands.ValidateCommand
        });
        extensions.journeyComponents.addCommand({
            id: "navigate",
            component: commands.NavigateCommand
        });
        extensions.journeyComponents.addCommand({
            id: "setValue",
            component: commands.SetValueCommand
        });
        extensions.journeyComponents.addCommand({
            id: "pdfIllustration",
            component: commands.PdfIllustrationCommand
        });
        extensions.journeyComponents.addCommand({
            id: journey_model_1.CommandTypes.LOG,
            component: commands.LogCommand
        });
        extensions.journeyComponents.addCommand({
            id: journey_model_1.CommandTypes.GENERATE_DOCUMENT,
            component: commands.GenerateDocumentCommand
        });
        extensions.journeyComponents.addCommand({
            id: "showModal",
            component: commands.ShowModalCommand
        });
        extensions.journeyComponents.addCommand({
            id: "validateQuestion",
            component: commands.ValidateQuestionCommand
        });
        extensions.journeyComponents.addCommand({
            id: "authenticate",
            component: commands.AuthenticateCommand
        });
        extensions.journeyComponents.addCommand({
            id: "navigateToUrl",
            component: commands.NavigateToUrlCommand
        });
        extensions.journeyComponents.addCommand({
            id: "issueBindingQuote",
            component: commands.IssueBindingQuoteCommand
        });
        extensions.journeyComponents.addCommand({
            id: "signAgreement",
            component: commands.SignAgreementCommand
        });
        extensions.journeyComponents.addCommand({
            id: "enrichment",
            component: commands.InteractionOutputBackendCommand
        });
        extensions.journeyComponents.addCommand({
            id: "loadInteractionForChange",
            component: commands.InteractionOutputBackendCommand
        });
        extensions.journeyComponents.addCommand({
            id: "loadState",
            component: commands.LoadStateCommand
        });
        extensions.journeyComponents.addCommand({
            id: "scrollOnValidate",
            component: commands.ScrollOnValidateCommand
        });
        extensions.journeyComponents.addCommand({
            id: "printDebugInfo",
            component: commands.PrintDebugInformationCommand
        });
        extensions.journeyComponents.addCommand({
            id: "clickButtonOnKeyDown",
            component: commands.ClickButtonOnKeyDownCommand
        });
        extensions
            .routes
            .add({
            path: "/sessionExpired",
            component: SessionErrorPage_1.default,
            exact: false
        });
        // Messages
        extensions.i18n.addMessages(messages_1.default);
        // Services
        extensions.services.bind(Types_1.Types.RuntimeServiceConfig).toConstantValue(configuration.runtimeService);
        extensions.services.bind(Types_1.Types.JourneyRuntimeService).to(services.JourneyRuntimeServiceImpl);
        extensions.services.bind(Types_1.Types.JourneyRendererServices).to(services.JourneyRendererServices);
        extensions.services.bind(Types_1.Types.LookupService).to(services.LookupService);
        extensions.services.bind(Types_1.Types.QuestionValidator).to(journeyServices.QuestionValidator);
        extensions.services.bind(Types_1.Types.PageValidator).to(journeyServices.PageValidator);
        extensions.services.bind(Types_1.Types.CommandsExecutor).to(services.CommandsExecutor);
        extensions.services.bind(journeyServices.Types.ValidationCommandsExecutor).to(services.CommandsExecutor);
        extensions.services.bind(Types_1.Types.PropositionEngine).to(services.PropositionEngineImpl);
        journeyServices.registerValidators(extensions.services.get(core_1.TypeDefs.JourneyComponentsManager));
    },
};
__exportStar(require("./context"), exports);
exports.default = plugin;
__exportStar(require("./Types"), exports);
__exportStar(require("./services"), exports);
__exportStar(require("./commands"), exports);
__exportStar(require("./widgets"), exports);
__exportStar(require("./navigator"), exports);
var PluginJourneyRenderingPage_2 = require("./pages/PluginJourneyRenderingPage");
Object.defineProperty(exports, "PluginJourneyRenderingPage", { enumerable: true, get: function () { return PluginJourneyRenderingPage_2.PluginJourneyRenderingPage; } });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/index.js
// module id = 3
// module chunks = 0